import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './error-logger.ts';

const msalConfig = {
  auth: {
    clientId: 'ff5cb599-1884-44f0-932c-8915ca4a94d7',
    // clientId: "998dedd0-88d3-4c1e-a6ef-ebb3301b0198",
    authority: 'https://login.microsoftonline.com/b63ddf11-4662-4df6-bd91-14dd00d3262e',
    redirectUri: window.location.origin, // Always redirect to base URL
  },
  cache: {
    cacheLocation: 'localStorage', // Use localStorage instead of sessionStorage for persistence
    storeAuthStateInCookie: true, // Enable cookie storage for better persistence
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(`[MSAL ${level}]: ${message}`);
      },
      piiLoggingEnabled: false,
      logLevel: 'Warning',
    },
    // Set token renewal offset to be more aggressive about renewing tokens
    tokenRenewalOffsetSeconds: 1800, // Renew 30 minutes before expiry
    navigateFrameWait: 0,
  },
};

const pca = new PublicClientApplication(msalConfig);

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <MsalProvider instance={pca}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </ErrorBoundary>
);
